import { useQuery } from '@tanstack/react-query';
import { fetchRoleById } from '../services/roles';
import { roleKeys } from './useRolesQuery';
import type { RoleRecord } from '../types/roles.types';

export const useRoleQuery = (id: string) =>
  useQuery<RoleRecord>({
    queryKey: roleKeys.detail(id),
    queryFn: () => fetchRoleById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
